module.exports = __webpack_public_path__ + "img/twoRow.d6d278a0.svg";